export const smartyAddressPopulation = () => {
    
    var counter = 0;
    
    if($('#autoAddress')){
        var addressId = $('#autoAddress').attr('data-addressId');
        $('#'+ addressId + "-copy").val($('#' + addressId).val());

        if(navigator && navigator.userAgent && navigator.userAgent.toLowerCase().indexOf("chrome") > 1) {
            $("#" + addressId).attr("autocomplete", "do-not-autofill");
        }
        $('#' + addressId).on("change", function() {
            $('#'+ addressId + "-copy").val($('#' + addressId).val());
        });
        $('#' + addressId).on('keyup', (e)=>{ 0
            $('#'+ addressId + "-copy").val($('#' + addressId).val());
            if(e.key != 'Tab'){
                counter++;
                var addr1 = $('#' + addressId).val();
                if(counter % 3 == 0 && addr1 > ''){
                    ajaxCall("autoAddress");
                }
                if(!addr1 > ''){
                    $('#autoAddress').empty();
                    $('#autoAddress').hide();
                }
            }

        });

        if($('#autoAddressQC')){
            var addressIdQC = $('#autoAddressQC').attr('data-addressId');
            $('#'+ addressIdQC + "-copy").val($('#' + addressIdQC).val());

            if(navigator && navigator.userAgent && navigator.userAgent.toLowerCase().indexOf("chrome") > 1){
                $("#" + addressIdQC).attr("autocomplete", "do-not-autofill");
            }
            $('#' + addressIdQC).on("change", function() {
                $('#'+ addressIdQC + "-copy").val($('#' + addressIdQC).val());
            });
            $('#' + addressIdQC).on('keyup', (e)=>{
                $('#'+ addressIdQC + "-copy").val($('#' + addressIdQC).val());
                if(e.key != 'Tab'){
                    counter++;
                    var addr1 = $('#' + addressIdQC).val();
                    if(counter % 3 == 0 && addr1 > ''){
                        ajaxCall("autoAddressQC");
                    }
                    if(!addr1 > ''){
                        $('#autoAddressQC').empty();
                        $('#autoAddressQC').hide();
                    }
                }
            }); 
        }

        if($('#autoAddressReg1')){
            var addressIdReg1 = $('#autoAddressReg1').attr('data-addressId');
            $('#'+ addressIdReg1 + "-copy").val($('#' + addressIdReg1).val());

            if(navigator && navigator.userAgent && navigator.userAgent.toLowerCase().indexOf("chrome") > 1){
                $("#" + addressIdReg1).attr("autocomplete", "do-not-autofill");
            }
            $('#' + addressIdReg1).on("change", function() {
                $('#'+ addressIdReg1 + "-copy").val($('#' + addressIdReg1).val());
            });
            $('#' + addressIdReg1).on('keyup', (e)=>{
                $('#'+ addressIdReg1 + "-copy").val($('#' + addressIdReg1).val());
                if(e.key != 'Tab'){
                    counter++;
                    var addr1 = $('#' + addressIdReg1).val();
                    if(counter % 3 == 0 && addr1 > ''){
                        ajaxCall("autoAddressReg1");
                    }
                    if(!addr1 > ''){
                        $('#autoAddressReg1').empty();
                        $('#autoAddressReg1').hide();
                    }
                }
            }); 
        }

        if($('#autoAddressReg2')){
            var addressIdReg2 = $('#autoAddressReg2').attr('data-addressId');
            $('#'+ addressIdReg2 + "-copy").val($('#' + addressIdReg2).val());

            if(navigator && navigator.userAgent && navigator.userAgent.toLowerCase().indexOf("chrome") > 1){
                $("#" + addressIdReg2).attr("autocomplete", "do-not-autofill");
            }
            $('#' + addressIdReg2).on("change", function() {
                $('#'+ addressIdReg2 + "-copy").val($('#' + addressIdReg2).val());
            });
            $('#' + addressIdReg2).on('keyup', (e)=>{
                $('#'+ addressIdReg2 + "-copy").val($('#' + addressIdReg2).val());
                if(e.key != 'Tab'){
                    counter++;
                    var addr1 = $('#' + addressIdReg2).val();
                    if(counter % 3 == 0 && addr1 > ''){
                        ajaxCall("autoAddressReg2");
                    }
                    if(!addr1 > ''){
                        $('#autoAddressReg2').empty();
                        $('#autoAddressReg2').hide();
                    }
                }
            }); 
        }

        if($('#autoAddressReg3')){
            var addressIdReg3 = $('#autoAddressReg3').attr('data-addressId');
            $('#'+ addressIdReg3 + "-copy").val($('#' + addressIdReg3).val());

            if(navigator && navigator.userAgent && navigator.userAgent.toLowerCase().indexOf("chrome") > 1){
                $("#" + addressIdReg3).attr("autocomplete", "do-not-autofill");
            }
            $('#' + addressIdReg3).on("change", function() {
                $('#'+ addressIdReg3 + "-copy").val($('#' + addressIdReg3).val());
            });
            $('#' + addressIdReg3).on('keyup', (e)=>{
                $('#'+ addressIdReg3 + "-copy").val($('#' + addressIdReg3).val());
                if(e.key != 'Tab'){
                    counter++;
                    var addr1 = $('#' + addressIdReg3).val();
                    if(counter % 3 == 0 && addr1 > ''){
                        ajaxCall("autoAddressReg3");
                    }
                    if(!addr1 > ''){
                        $('#autoAddressReg3').empty();
                        $('#autoAddressReg3').hide();
                    }
                }
            }); 
        }

        $(document).on('click', function (e) {
            // had to move setting the width to here, for cases where the width has changed on the existing element
            if($("#" + addressId).is(":visible")){
                $('#autoAddress').width($("#" + addressId).outerWidth() - 2);
            }
            if($("#" + addressIdReg1).is(":visible")){
                $('#autoAddressReg1').width($("#" + addressIdReg1).outerWidth() - 2);
            }
            if($("#" + addressIdReg2).is(":visible")){
                $('#autoAddressReg2').width($("#" + addressIdReg2).outerWidth() - 2);
            }
            if($("#" + addressIdReg3).is(":visible")){
                $('#autoAddressReg3').width($("#" + addressIdReg3).outerWidth() - 2);
            }
            if($("#" + addressIdQC).is(":visible")){
                $('#autoAddressQC').width($("#" + addressIdQC).outerWidth() - 2);
            }

            if(e.target.id == addressId){
                if($('#autoAddress li').length > 0){
                    $('#autoAddress').show();
                }
            } else {
                $("#autoAddress").hide();
            }

            if(e.target.id == addressIdReg1){
                if($('#autoAddressReg1 li').length > 0){
                    $('#autoAddressReg1').show();
                }
            } else {
                $("#autoAddressReg1").hide();
            }

            if(e.target.id == addressIdReg2){
                if($('#autoAddressReg2 li').length > 0){
                    $('#autoAddressReg2').show();
                }
            } else {
                $("#autoAddressReg2").hide();
            }

            if(e.target.id == addressIdReg3){
                if($('#autoAddressReg3 li').length > 0){
                    $('#autoAddressReg3').show();
                }
            } else {
                $("#autoAddressReg3").hide();
            }

            if(e.target.id == addressIdQC){
                if($('#autoAddressQC li').length > 0){
                    $('#autoAddressQC').show();
                }
            } else {
                $("#autoAddressQC").hide();
            }
        });
    }
};

function clickLi(e){
    
    var ulId = e.currentTarget.offsetParent.id;
    var suggestion = e.currentTarget.children;
    var addressId = $('#' + ulId).attr('data-addressId');
    var address2Id = $('#' + ulId).attr('data-address2Id');
    var cityId = $('#' + ulId).attr('data-cityId');
    var stateId = $('#' + ulId).attr('data-stateId');
    var zipId = $('#' + ulId).attr('data-zipId');

    

    if(suggestion[5].innerHTML <= 1){
        $('#' + addressId).val(suggestion[0].innerHTML + " " + suggestion[1].innerHTML).trigger("change");
        $('#' + cityId).val(suggestion[2].innerHTML).trigger("change");
        $('#' + stateId).val(suggestion[3].innerHTML).trigger("change");
        $('#' + zipId).val(suggestion[4].innerHTML).trigger("change");
        $('#' + ulId).hide();
    }
    else {
        var selected = suggestion[0].innerHTML + " " 
        +suggestion[1].innerHTML + " "
        +"%28" + suggestion[5].innerHTML + "%29+"
        +suggestion[2].innerHTML + " "
        +suggestion[3].innerHTML + "%2C+"
        +suggestion[4].innerHTML;
        selected = selected.split(' ').join('+');
        selected = selected.split('#').join('%23');
        ajaxCallSelected(selected, suggestion[0].innerHTML, ulId);
    }
}

function ajaxCall(ulId){
    var addressId = $('#' + ulId).attr('data-addressId');
    var addr1 = $('#' + addressId).val();
    var smartyKey = $('#' + ulId).attr('data-smarty');
    if(addr1 > ''){
        $.ajax({
            url         : `https://us-autocomplete-pro.api.smarty.com/lookup?key=${smartyKey}&max_results=10&search=`
            + addr1 
            + "&prefer_geolocation=CITY&source=postal",
            cache       : false,
            type        : "GET",
            dataType    : "json",
            error       : function() {
                //console.log("error");
            },
            success     : function(json) {
                populateAutoAddress(json, ulId);
            }
        });
    }
    else {
        $('#' + ulId).empty();
        $('#' + ulId).hide();
    }
 }

function ajaxCallSelected(selected, addr1, ulId){
    var smartyKey = $('#' + ulId).attr('data-smarty');
    $.ajax({
        url         : `https://us-autocomplete-pro.api.smarty.com/lookup?key=${smartyKey}&max_results=10&search=`
        + addr1 
        + "&selected=" + selected + "&source=all",
        cache       : false,
        type        : "GET",
        dataType    : "json",
        error       : function() {
            console.log("error");
        },
        success     : function(json) {
            populateAutoAddress(json, ulId);
        }
    });
 }

 function populateAutoAddress(jsonResponse, ulId) {
     $('#' + ulId).empty();
     if(jsonResponse.suggestions.length >= 1) {
         jsonResponse.suggestions.forEach((suggestion, index)=>{
             if(index < 10){ 
                var li = $('<li tabindex="0"><span>' + suggestion.street_line + '</span>' + 
                ' <span>' + suggestion.secondary + '</span>' +
                ' <span>' + suggestion.city + '</span>,' +
                ' <span>' + suggestion.state + '</span>' +
                ' <span>' + suggestion.zipcode + '</span>' +
                ' <span style="display:none;">' + suggestion.entries + '</span></li>');
                if(suggestion.entries > 1){
                    li.append($('<span> (' + suggestion.entries + ' more entries)</span>'));
                }
                $('#' + ulId).append(li);
                li.on("click ", clickLi);
                li.on("keydown", (e) => {
                    if(e.key == 'Enter') {
                        clickLi(e);
                    }
                    if(e.key == 'Tab' && index == jsonResponse.suggestions.length - 1){
                        $('#' + ulId).hide();

                    }
                });
             }
         });

        $('#' + ulId).show();
     }
     else {
         $('#' + ulId).hide();
     }
 }



